import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import b2bService from '../../services/b2bService';
import './B2bPortalLayout.css';

const B2bPortalLayout = () => {
  const navigate = useNavigate();

  // Retrieve client portal user details from sessionStorage (Zero-Trust Session Isolation)
  const portalUserData = (() => {
    try {
      return JSON.parse(sessionStorage.getItem('b2b_portal_user') || '{}');
    } catch {
      return {};
    }
  })();

  const handleLogout = async () => {
    try {
      await b2bService.portalLogout();
    } catch (err) {
      console.warn('Logout server notification failed:', err);
    } finally {
      sessionStorage.removeItem('b2b_portal_token');
      sessionStorage.removeItem('b2b_portal_user');
      navigate('/b2b/login');
    }
  };

  return (
    <div className="b2b-portal-shell">
      <header className="b2b-portal-header">
        <div className="b2b-header-inner">
          <div className="b2b-brand-section">
            <span className="b2b-brand-badge">B2B Portal</span>
            <div>
              <h1 className="b2b-portal-title">Client Access Hub</h1>
              <div className="b2b-party-name">
                {portalUserData.partyName || 'Diagnostic Partner'} ({portalUserData.partyCode || 'B2B'})
              </div>
            </div>
          </div>

          <nav className="b2b-nav-links">
            <NavLink
              to="/b2b/portal/dashboard"
              className={({ isActive }) => `b2b-nav-link ${isActive ? 'active' : ''}`}
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/b2b/portal/orders"
              className={({ isActive }) => `b2b-nav-link ${isActive ? 'active' : ''}`}
            >
              Orders & Reports
            </NavLink>
            <NavLink
              to="/b2b/portal/invoices"
              className={({ isActive }) => `b2b-nav-link ${isActive ? 'active' : ''}`}
            >
              Invoices
            </NavLink>
            <NavLink
              to="/b2b/portal/ledger"
              className={({ isActive }) => `b2b-nav-link ${isActive ? 'active' : ''}`}
            >
              Financial Ledger
            </NavLink>
          </nav>

          <div className="b2b-user-section">
            <div className="b2b-user-info">
              <div className="b2b-user-name">{portalUserData.fullName || portalUserData.username || 'Authorized User'}</div>
              <div className="b2b-user-role">{portalUserData.role || 'Client'}</div>
            </div>
            <button className="b2b-logout-btn" onClick={handleLogout} title="Sign out of client portal">
              Sign Out
            </button>
          </div>
        </div>
      </header>

      <main className="b2b-portal-main">
        <Outlet />
      </main>

      <footer className="b2b-portal-footer">
        &copy; {new Date().getFullYear()} My LIS Enterprise — Secure B2B Laboratory Interoperability Portal.
      </footer>
    </div>
  );
};

export default B2bPortalLayout;
